import React from 'react';
import { Quote, Star, Asterisk } from 'lucide-react';
import { testimonials } from '../data/mock';

const Testimonials = () => {
  const doubled = [...testimonials, ...testimonials];
  return (
    <section className="relative py-20 lg:py-28 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 mb-12">
        <div className="grid lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 text-sm font-medium text-[#C41E3A] mb-4">
              <Asterisk className="w-4 h-4" /> Client Voice
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-[3.5rem] font-extrabold text-neutral-900 leading-[1.05]">
              Trusted by manufacturers, importers &amp; brands
            </h2>
          </div>
          <div className="lg:col-span-5">
            <div className="flex items-end gap-4">
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-[#C41E3A] text-[#C41E3A]" />
                ))}
              </div>
              <div>
                <div className="font-display text-2xl font-bold text-neutral-900">4.9/5.0</div>
                <div className="text-xs text-neutral-500">Avg. client rating · hover strip to pause</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="marquee-wrap relative">
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#FDFBF7] to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#FDFBF7] to-transparent z-10 pointer-events-none" />
        <div className="marquee-track py-4 gap-5">
          {doubled.map((t, i) => (
            <figure
              key={i}
              className="w-[380px] md:w-[460px] shrink-0 bg-white border border-neutral-200 rounded-[1.75rem] p-8 lift hover:border-[#C41E3A]/50 hover:shadow-lg"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="w-11 h-11 rounded-2xl bg-rose-50 flex items-center justify-center">
                  <Quote className="w-5 h-5 text-[#C41E3A]" />
                </div>
                <div className="flex items-center gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-3.5 h-3.5 fill-[#C41E3A] text-[#C41E3A]" />
                  ))}
                </div>
              </div>
              <blockquote className="font-display text-lg md:text-xl text-neutral-900 leading-snug mb-6">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="flex items-center gap-3 pt-4 border-t border-neutral-100">
                <div className="w-10 h-10 rounded-full bg-[#0A0E1A] flex items-center justify-center text-white font-display font-bold text-sm">
                  {t.author[0]}
                </div>
                <div>
                  <div className="text-sm font-semibold text-neutral-900">{t.author}</div>
                  <div className="text-xs text-neutral-500">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
